import { getBaseURL } from "@storytell/cp-client";
import type { DetectedOS } from "~/lib/useOS";

/**
 * Installer URL for the visitor's OS. The endpoint resolves darwin when no
 * platform is named, so only windows has to say so — which also keeps the
 * pre-hydration "unknown" render pointing at a link that works.
 */
export const chiefDownloadHref = (os: DetectedOS): string | undefined => {
  const base = getBaseURL();
  if (!base.isOk()) return undefined;
  const href = `${base.value}/chief/live/download`;
  return os === "windows" ? `${href}?platform=windows` : href;
};

// Which visitors get an installer rather than the waitlist. "unknown" counts:
// it is the value every render carries until useOS resolves after mount, and
// falling back to the macOS build beats flashing a waitlist at a Mac user.
export const hasChiefBuild = (os: DetectedOS): boolean => os === "mac" || os === "windows" || os === "unknown";

export const chiefOSLabel = (os: DetectedOS): string => (os === "windows" ? "Windows" : "macOS");
